
import makerjs from "makerjs";
function C40(model, zoom, Param, fixedParam) {
  //w,h,w1,w2
  console.log("Param==", Param[0].param);
  // console.log("Param==",Param[1].param);
  console.log("Param==", Param);
  var plate = model.plate, markers = model.markers, myZoom = zoom * 1,
    R = Param[0].param, R1 = Param[1].param, D = Param[2].param, NF = Param[3].param,
    //  plate = model.plate, markers = model.markers,
    markShift = fixedParam.markShift * 1, markShiftTwo = fixedParam.markShiftTwo * 1,
    markShiftThree = fixedParam.markShiftThree * 1, markShiftFour = fixedParam.markShiftFour * 1, markHolesOneD = fixedParam.markHolesOneD * 1,

    r = R * 1 * myZoom,
    r1 = R1 * 1 * myZoom,
    d = D * 1 * myZoom,
    HolesNum = NF * 1 * myZoom,
    h = 2 * r,
    w = 2 * r,

    rotate = 360 / HolesNum,
    // sinX = Math.sin(rotate * (Math.PI / 180)),
    // cosX = Math.cos(rotate * (Math.PI / 180)),
    rd1 = r1 / Math.sqrt(2),
    rd = r / Math.sqrt(2),
    // x0 = X*1*myZoom,
    // y0 = Y*1*myZoom;
    /**
     * sin60=Math.sqrt(3)/2
     * cos60=1/2
     * 
     */

    x = r, y = r, glassH = h, glassW = w;

  if (r !== 0) {
    var TxtR = "R=" + R;
  } if (r1 !== 0) {
    var TxtR1 = "R1=" + R1;
  } if (d !== 0) {
    var TxtD = "D=" + D;
  }

  // var obj = {};
  
  var drawAbnormalShapeC40 = {
    paths: {
      "largeCircle": new makerjs.paths.Circle([r, r], r),
      // "smallHolesOne": new makerjs.paths.Circle([r + wd, r + hd], r1),
      // "smallHolesTwo": new makerjs.paths.Circle([r + d / 2, r + hd], r1),
      // "smallHolesThree": new makerjs.paths.Circle([r - d / 2, r + hd], r1),
      // "smallHolesFour": new makerjs.paths.Circle([r - d, r], r1),
      // "smallHolesFive": new makerjs.paths.Circle([r - d / 2, r - hd], r1),
      // "smallHolesSix": new makerjs.paths.Circle([r + d / 2, r - hd], r1),
    }
  };
  for (let i = 0; i < HolesNum; i++) {
    var hd = d * Math.sin(rotate * (Math.PI / 180) * i);
      var wd = d * Math.cos(rotate * (Math.PI / 180) * i);
      drawAbnormalShapeC40.paths["smallHoles" + i] = new makerjs.paths.Circle([r + wd, r + hd], r1);
    // cutPlate.models["TypeCorner_myFloorSpring3H" + areaPoint] = ObjName[3];
  }
  console.log("drawAbnormalShapeC40===", drawAbnormalShapeC40);
  var drawAbnormalShapeC40MarkR = {
    paths: {
      "LeftLine": new makerjs.paths.Line([r, r], [r + rd, r + rd]),
    }
  };
  var drawAbnormalShapeC40MarkD = {
    paths: {
      "LeftLine": new makerjs.paths.Line([r, r], [r + d, r]),
    }
  };
  var drawAbnormalShapeC40MarkR1 = {
    paths: {
      "LeftLine": new makerjs.paths.Line([r + d, r], [r + d + r1, r]),
    }
  };
  makerjs.model.addCaption(drawAbnormalShapeC40MarkR, TxtR, [r + rd, r + rd + markShift], [r + rd + 3 * markShift, r + rd + markShift]);//长度文字
  makerjs.model.addCaption(drawAbnormalShapeC40MarkD, TxtD, [r, r + 2 * markShift], [r + d, r + 2 * markShift]);//长度文字
  makerjs.model.addCaption(drawAbnormalShapeC40MarkR1, TxtR1, [r + d, r + 2 * markShift], [r + d + r1, r + 2 * markShift]);//长度文字  

  plate = {
    models: {
      drawAbnormalShapeC40: drawAbnormalShapeC40,
    }
  };
  markers = {
    models: {
      drawAbnormalShapeC40: drawAbnormalShapeC40,
      drawAbnormalShapeC40MarkR: drawAbnormalShapeC40MarkR,
      drawAbnormalShapeC40MarkD: drawAbnormalShapeC40MarkD,
      drawAbnormalShapeC40MarkR1: drawAbnormalShapeC40MarkR1,
    }
  };

  /*****************************************************************************/
  //return { plate, markers, glassW, glassH }

  return { w, h, plate, markers }
};


export default C40;